import React from 'react';
import colors from 'utils/colors';
import {
  Table,
  TableHeader,
  TableData,
  TableRow,
} from 'components/styled-components';
import { NonIdealState } from '@blueprintjs/core';
import map from 'lodash/map';

const fields = ['Name', 'Email', 'User Status'];

const UserTable = ({ users }) => (
  <Table>
    <tbody>
      <TableRow background={colors.whiteGray}>
        {fields.map((field, i) => (
          <TableHeader key={`${field}-${i}`}>{field}</TableHeader>
        ))}
      </TableRow>
      {users ? (
        map(users, u => (
          <TableRow key={u.userID}>
            <TableData>
              {u.firstName} {u.lastName}
            </TableData>
            <TableData>{u.email}</TableData>
            <TableData>{u.status}</TableData>
          </TableRow>
        ))
      ) : (
        <tr>
          <TableData colSpan={fields.length}>
            <NonIdealState
              icon="info-sign"
              title="There are no users under your management."
              description="Once you have users to manage they will appear here. The system did not find any associated with your account."
            />
          </TableData>
        </tr>
      )}
    </tbody>
  </Table>
);

export default UserTable;
